import type { SupportedApp } from '../types';

const ALL_APPS: SupportedApp[] = ['confluence', 'projects', 'goals', 'teams', 'focus'];

type EdgeGroup = {
	edges: string[];
};

const EDGE_GROUPS: Record<SupportedApp, EdgeGroup> = {
	confluence: {
		edges: [
			'user_favorited_confluence_page',
			'user_favorited_confluence_blogpost',
			'user_favorited_confluence_whiteboard',
			'user_favorited_confluence_database',
		],
	},
	projects: {
		edges: ['user_favorited_townsquare_project'],
	},
	goals: {
		edges: ['user_favorited_townsquare_goal'],
	},
	teams: {
		edges: ['user_favorited_team'],
	},
	focus: {
		edges: ['user_favorited_focus_area'],
	},
};

export const starredQueryBuilder = (
	currentUserAri: string,
	specifiedApps: SupportedApp[],
): string => {
	if (specifiedApps.length === 0) {
		return globalStarredQueryBuilder(currentUserAri);
	}

	const edges = specifiedApps.flatMap((app: SupportedApp) => {
		return EDGE_GROUPS[app]?.edges ?? [];
	});

	return buildCypherQueryWithEdges(currentUserAri, edges);
};

export const globalStarredQueryBuilder = (currentUserAri: string): string => {
	const edges = ALL_APPS.flatMap((app) => EDGE_GROUPS[app]?.edges ?? []);

	return buildCypherQueryWithEdges(currentUserAri, edges);
};

const buildCypherQueryWithEdges = (currentUserAri: string, edges: string[]): string => {
	return `MATCH (user: IdentityUser {ari: '${currentUserAri}'})-[rel:${edges.join(
		'|',
	)}]->(entity) RETURN entity, rel.createdAt ORDER BY rel.createdAt DESC`;
};
